import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full_content" }

import MainHeader from "./views/main-header.vue";
import MainFooter from "@/views/main-footer.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader, { class: "main-header" }),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_router_view, { class: "full_content__page" })
    ])
  ], 64))
}
}

})